import { baseRequestWithHeaders } from './baseRequest';

export const sendLogoutRequest = () => {
    const url = '/new-ops/logout';
    const method = 'POST';
    const data = {};
    return baseRequestWithHeaders(url, method, null, data);
};
